'use client'

import type {
  GlobalContextData,
  GlobalContextProps,
  GlobalContextProviderProps,
} from '@maestro/core/types/global.types'

import React, { createContext, useContext, useState } from 'react'

const GlobalContext = createContext<GlobalContextProps>({
  preloadedProductData: {},
  searchProductIndex: '',
  setPreloadedProductData: () => null,
})

export const GlobalContextProvider = ({
  children,
  searchProductIndex,
}: GlobalContextProviderProps) => {
  const [preloadedProductData, setPreloadedProductData] =
    useState<GlobalContextData>({})
  return (
    <GlobalContext.Provider
      value={{
        preloadedProductData,
        searchProductIndex,
        setPreloadedProductData,
      }}
    >
      {children}
    </GlobalContext.Provider>
  )
}

export const useGlobalContext = () => useContext(GlobalContext)
